import { cls } from "utils/util";

const PageWrapper = ({
  title,
  widthType = "base",
  children,
  className,
}: {
  title?: React.ReactNode;
  widthType?: "wide" | "narrow" | "screen" | "base" | "full";
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <article
      className={cls(
        widthType === "screen"
          ? "w-screen"
          : widthType === "wide"
          ? "w-wide"
          : widthType === "full"
          ? "w-full"
          : widthType === "narrow"
          ? "w-[500px]"
          : "w-[1200px]",
        "mx-auto p-5 lg:px-0 lg:py-10 max-w-[100%] min-h-[100vh]",
        className ? className : "",
      )}
    >
      {title && <PageTitle title={title} />}
      {children}
    </article>
  );
};

export default PageWrapper;

export const PageTitle = ({ title }: { title: React.ReactNode }) => {
  return <h1 className="text-lg font-semibold animate-fadedown mb-5">{title}</h1>;
};
